module.exports = __webpack_public_path__ + "img/28200.d7a6caa5.jpg";